import PropTypes from 'prop-types';

import { ORDER_ACTIONS } from '@/common/constants';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import { IsLoadingDefaultProps } from '@/common/proptypes/Base/IsLoading.proptypes';

export const ShippingRequestDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  items: [],
  onShippingRequest: () => {},
  orderId: null,
  reference: null,
  refetchOrder: () => {},
  showWarning: false,
  type: ORDER_ACTIONS.SHIPPING_REQUEST,
};

export const ShippingRequestPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingDefaultProps,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onShippingRequest: PropTypes.func,
  orderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  reference: PropTypes.string,
  refetchOrder: PropTypes.func,
  showWarning: PropTypes.bool,
  type: PropTypes.string,
};
